/**
 * Created by Omar Alejandro Leonor Avalos
 * Main Menu
 */
import React, { Component } from 'react';
import NNext from 'material-ui/svg-icons/image/navigate-next';
import Account from 'material-ui/svg-icons/action/account-circle';
import Logout from 'material-ui/svg-icons/action/power-settings-new';
import Close from 'material-ui/svg-icons/content/clear';
import { FlatButton, Dialog } from 'material-ui';
import { logout } from '../security';
import { Logout as LogoutModal } from '../modals';

class Menu extends Component {

    constructor() {
        super();
        this.state = { confirmLogoutOpen: false };
    }

    render() {
        const { menu } = this.props;
        const { confirmLogoutOpen } = this.state;

        return (
            <div className="modal fade modal-fullscreen-menu" id="modalNavigation" role="dialog" tabIndex="-1">
                <button aria-label="Close" className="close" data-dismiss="modal" type="button" >
                    <Close color="#FFF" style={{ height: '4rem', width: '4rem' }} />
                </button>
                <div className="modal-dialog">
                    <nav className="list-group">
                        <img
                            role="presentation"
                            style={{ width: 160, paddingBottom: '2rem' }}
                            src="images/logo-title-light.png"
                        />
                        {
                            menu.filter(x => x.key !== 'noContent').map((item, index) => {
                                return (
                                    <a className="list-group-item" href={item.path} key={index}>
                                        <NNext /> {item.title}
                                    </a>
                                );
                            })
                        }
                        <hr />
                        <div className="menu-footer">
                            <a
                                className="list-group-item"
                                href="/"
                                onClick={(event) => {
                                    event.preventDefault();
                                    this.setState({ confirmLogoutOpen: true });
                                }}
                            >
                                <Logout color="#FFF" /> &nbsp; Cerrar Sesión
                            </a>
                        </div>
                    </nav>
                </div>
                <LogoutModal
                    open={confirmLogoutOpen}
                    onCancel={() => this.setState({ confirmLogoutOpen: false })}
                />
            </div>
        );
    }
}
export default Menu;



// WEBPACK FOOTER //
// ./modals/menu.js